import { IApiRequestConfig } from '../api.types';
import { IPaymentMethod } from '../../resource/payment-method/payment-method.types';

export const createSetupIntentApi = (): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'createSetupIntent',
  action: 'payment-methods/setup-intent',
  method: 'post',
  v2: true,
});

export const getPaymentMethodsApi = (): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'getPaymentMethods',
  action: 'payment-methods',
  method: 'get',
  v2: true,
});

export const createPaymentMethodApi = (token: string, externalSetupRef: string): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'createPaymentMethod',
  action: 'payment-methods',
  method: 'post',
  data: { token, externalSetupRef },
  v2: true,
});

export const setDefaultPaymentMethodApi = (id: IPaymentMethod['id']): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'setDefaultPaymentMethod',
  action: `payment-methods/${id}/default`,
  method: 'patch',
  v2: true,
});

export const deletePaymentMethodApi = (id: IPaymentMethod['id']): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'deletePaymentMethod',
  action: `payment-methods/${id}`,
  method: 'delete',
  v2: true,
});

export const getPaymentsApi = (): IApiRequestConfig<unknown> => ({
  apiRouteKey: 'getPayments',
  action: 'payments',
  method: 'get',
  v2: true,
});
